import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import svgIconCloseBtn from '../../../assets/svg/close.svg';
import svgInfoIcon from '../../../assets/svg/info.svg';
import svgIconOk from '../../../assets/svg/ok.svg';
import SvgIcon from '../../svg-icon';

const InfoWrapper = styled.div`
  display: flex;
  margin-bottom: 5px;
  justify-content: center;
  align-items: center;
  padding: 8px;
  /* padding-left: 11px; */

  &:last-child {
    margin-bottom: 0px;
  }

  .icon {
    padding: 0px 11px;
  }

  .text {
    margin-bottom: 0px;
    padding-top: 2px;
    color: ${({ theme, textStyle }) => theme.colors[textStyle].color};
  }
`;

function TextInfo({ text, styling }) {
  if (text === null || text === undefined) {
    return null;
  }

  function getStyling() {
    switch (styling) {
      case 'error':
        return { style: 'error', icon: svgIconCloseBtn };
      case 'info':
        return { style: 'primary', icon: svgInfoIcon };
      case 'success':
        return { style: 'success', icon: svgIconOk };
      default:
        return { style: 'primary', icon: null };
    }
  }

  const { style, icon } = getStyling();

  return (
    <InfoWrapper key={text} textStyle={style}>
      <SvgIcon
        icon={icon}
        themed
        styling={style}
        active
        backgroundShade="60"
        customClass="icon"
      />
      <p className="text">{text}</p>
    </InfoWrapper>
  );
}

TextInfo.propTypes = {
  text: PropTypes.string.isRequired,
  styling: PropTypes.string
};

TextInfo.defaultProps = {
  styling: 'error'
};

export default TextInfo;
